// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ServerGroupDashboardServerTableQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  serverGroupId: Types.Scalars["ID"]["input"];
}>;

export type ServerGroupDashboardServerTableQuery = {
  __typename?: "GraphqlQuery";
  getServerGroupServers: Array<{
    __typename?: "ServerGroupServer";
    id: string;
    name: string;
    humanId: string;
    databaseCount: number;
    warningsCount: number;
    criticalsCount: number;
    latestStats?: {
      __typename?: "PostgresServerStats";
      isPrimary: boolean;
      standbyApplyByteLag?: number | null;
      standbyIsStreaming?: boolean | null;
    } | null;
  }>;
};

export const ServerGroupDashboardServerTableDocument = gql`
  query ServerGroupDashboardServerTable(
    $organizationSlug: ID!
    $serverGroupId: ID!
  ) {
    getServerGroupServers(
      organizationSlug: $organizationSlug
      serverGroupId: $serverGroupId
    ) {
      id
      name
      humanId
      databaseCount
      warningsCount
      criticalsCount
      latestStats {
        isPrimary
        standbyApplyByteLag
        standbyIsStreaming
      }
    }
  }
`;

/**
 * __useServerGroupDashboardServerTableQuery__
 *
 * To run a query within a React component, call `useServerGroupDashboardServerTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useServerGroupDashboardServerTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServerGroupDashboardServerTableQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      serverGroupId: // value for 'serverGroupId'
 *   },
 * });
 */
export function useServerGroupDashboardServerTableQuery(
  baseOptions: Apollo.QueryHookOptions<
    ServerGroupDashboardServerTableQuery,
    ServerGroupDashboardServerTableQueryVariables
  > &
    (
      | {
          variables: ServerGroupDashboardServerTableQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ServerGroupDashboardServerTableQuery,
    ServerGroupDashboardServerTableQueryVariables
  >(ServerGroupDashboardServerTableDocument, options);
}
export function useServerGroupDashboardServerTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServerGroupDashboardServerTableQuery,
    ServerGroupDashboardServerTableQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ServerGroupDashboardServerTableQuery,
    ServerGroupDashboardServerTableQueryVariables
  >(ServerGroupDashboardServerTableDocument, options);
}
// @ts-ignore
export function useServerGroupDashboardServerTableSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ServerGroupDashboardServerTableQuery,
    ServerGroupDashboardServerTableQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ServerGroupDashboardServerTableQuery,
  ServerGroupDashboardServerTableQueryVariables
>;
export function useServerGroupDashboardServerTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServerGroupDashboardServerTableQuery,
        ServerGroupDashboardServerTableQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ServerGroupDashboardServerTableQuery | undefined,
  ServerGroupDashboardServerTableQueryVariables
>;
export function useServerGroupDashboardServerTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServerGroupDashboardServerTableQuery,
        ServerGroupDashboardServerTableQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ServerGroupDashboardServerTableQuery,
    ServerGroupDashboardServerTableQueryVariables
  >(ServerGroupDashboardServerTableDocument, options);
}
export type ServerGroupDashboardServerTableQueryHookResult = ReturnType<
  typeof useServerGroupDashboardServerTableQuery
>;
export type ServerGroupDashboardServerTableLazyQueryHookResult = ReturnType<
  typeof useServerGroupDashboardServerTableLazyQuery
>;
export type ServerGroupDashboardServerTableSuspenseQueryHookResult = ReturnType<
  typeof useServerGroupDashboardServerTableSuspenseQuery
>;
export type ServerGroupDashboardServerTableQueryResult = Apollo.QueryResult<
  ServerGroupDashboardServerTableQuery,
  ServerGroupDashboardServerTableQueryVariables
>;
